import { QuarterCloseChecklistRowTitles } from '@shared/store/workflow/workflow-types';
import { Workflow } from '@shared/store/workflow/workflow.store';

export function closeExpensesRowCompleted(workflowList: Workflow[]): boolean {
  const closeExpensesRow = workflowList.find((workflow) => {
    return workflow.name === QuarterCloseChecklistRowTitles.CloseExpenses;
  });

  return closeExpensesRow?.properties.locked || false;
}
